import { computed } from 'vue';
import { useColors } from '@/composables';
import { useStore } from '@/store';

const EVENTS_USAGE_WARNING_PERCENT = 90;

export const useNavbarEvents = () => {
  const store = useStore();
  const $colors = useColors();

  const eventsUsagePercent = computed(() => {
    const { eventsUsed, eventsIncluded } = store.billing;
    if (!eventsIncluded) {
      return 0;
    }
    return (eventsUsed / eventsIncluded) * 100;
  });

  const isNavbarEventsRed = computed(
    () => eventsUsagePercent.value > EVENTS_USAGE_WARNING_PERCENT,
  );

  const stateColor = computed(() =>
    isNavbarEventsRed.value ? $colors.red : $colors.green,
  );

  const icon = computed(() =>
    isNavbarEventsRed.value
      ? 'fas fa-exclamation-circle'
      : 'fas fa-check-circle',
  );

  return {
    eventsUsagePercent,
    isNavbarEventsRed,
    stateColor,
    icon,
  };
};
